
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 86.81 16.49"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticStyle:{"isolation":"isolate"},attrs:{"data-name":"-e-iconTimerStyle3"}},[_c('path',{attrs:{"d":"M0 0h10v16.49H0zM13.88 0h10v16.49h-10zM31.47 0h10v16.49h-10zM45.35 0h10v16.49h-10zM62.94 0h10v16.49h-10zM76.82 0h10v16.49h-10z"}})])])
          )
        }
      }
    